<template>
    <div>
        <Single v-if='obj.state == 0' :imgList="obj.imgList" :money='obj.money' :logined="obj.logined"></Single>          
        <Multiple v-if='obj.state == 1' :imgList="obj.imgList" :list="obj.product_list" :logined="obj.logined"></Multiple>                  
    </div>    
</template>
<script>
import Single from '@/components/business/index/single.vue'
import Multiple from '@/components/business/index/multiple.vue'
import { reactive , onMounted} from 'vue'
import { home,index } from '../../api/index'
import { getToken,getTokenFromStorage } from '../../utils/tool'
import { useLoading } from 'vue-loading-overlay'
export default {
    components:{
        Single,
        Multiple
    },
    setup () {  
        const loading = useLoading()      
        const obj = reactive({
            state: 2,
            imgList: [],
            money: '',
            product_list:[],
            logined: getTokenFromStorage() || getToken()
        })
        onMounted(async () => {                   
            const loader = loading.show({
                container: null
            })                        
            const data = await home()
            const data_2 = await index()            
            loader.hide()
            if(data.code == 0 ) {
                if(data.data.page === 0) {
                    obj.state = 0
                    if(data_2.data.newBanners) {
                        obj.imgList = data_2.data.newBanners
                    }
                    obj.money = data_2.data.products[0].maxAmount
                } else {
                    obj.state = 1
                    obj.imgList = data_2.data.newBanners
                    obj.product_list = data_2.data.products
                }
            }                    
        })
        return {obj}
    }
}
</script>
